import { FormEvent, useRef, useState } from 'react';

export function ReferralForm({ onSubmit }: { onSubmit: (x: { name: string; email: string; note: string }) => Promise<void> }) {
  const [sent, setSent] = useState(false);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (inFlight.current) return;
    inFlight.current = true;
    const form = new FormData(e.currentTarget);
    setError('');
    setWorking(true);
    try {
      await onSubmit({
        name: String(form.get('name') ?? ''),
        email: String(form.get('email') ?? ''),
        note: String(form.get('note') ?? ''),
      });
      setSent(true);
    } catch {
      setError('We couldn’t send your referral. Please try again.');
    } finally {
      inFlight.current = false;
      setWorking(false);
    }
  }

  if (sent) {
    return (
      <div className="referral-success" role="status">
        <strong>Thank you.</strong>
        <span>We’ll take it from here.</span>
        <button type="button" className="button button--dark" onClick={() => setSent(false)}>Refer another person</button>
      </div>
    );
  }

  return (
    <form className="referral-form" onSubmit={submit}>
      <input name="name" required placeholder="Their name" />
      <input name="email" type="email" placeholder="Their email (optional)" />
      <textarea name="note" rows={3} placeholder="What makes their story worth telling?" />
      {error && <p role="alert" className="referral-form__error">{error}</p>}
      <button type="submit" className="button button--light" disabled={working}>{working ? 'Sending…' : 'Refer someone to ROAM'}</button>
    </form>
  );
}
